import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import React from 'react';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  to: string;
  label: string;
  icon?: IconDefinition;
  end?: boolean;
};

export function NavItem({ to, label, icon, end }: Props) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => {
        return clsx(
          'flex px-5 py-2 text-sm rounded-t-sm items-center font-light mr-2 border-t border-x',
          isActive
            ? 'bg-[linear-gradient(0deg,#4B5563,#4B5563),linear-gradient(180deg,rgba(2,6,23,0)_7.21%,rgba(7,8,15,0.13)_47.6%,rgba(9,9,11,0.2)_100%)] text-white border-gray-700'
            : 'bg-[linear-gradient(180deg,rgba(0,0,0,0)_73.08%,rgba(0,0,0,0.04)_100%)] border-t border-x border-gray-200'
        );
      }}>
      {icon && <FontAwesomeIcon icon={icon} />}
      <div className={icon ? 'ml-2' : ''}>{label}</div>
    </NavLink>
  );
}
